import * as actions from 'appRedux/actions/taxInvoice/taxBookActionType';
import { TaxBookItem } from 'routes/main/taxInvoice/types';

export interface TaxBookState {
  loader: boolean;
  dataSource: TaxBookItem[];
  error: string | null;
  process: {
    status: boolean;
    action: string;
    message: string;
  };
}

const initialState: TaxBookState = {
  loader: false,
  dataSource: [],
  error: null,
  process: {
    status: false,
    action: '',
    message: '',
  },
};

export default (
  state: TaxBookState = initialState,
  action: actions.TaxBookAction
): TaxBookState => {
  switch (action.type) {
    case actions.TAX_BOOK_REQUEST:
      return {
        ...state,
        loader: true,
        error: null,
        process: {
          status: false,
          action: 'taxBookRequest',
          message: '',
        },
      };

    case actions.TAX_BOOK_SUCCESS: {
      const response = action.payload;
      const items = response.data?.result_data || [];

      return {
        ...state,
        loader: false,
        dataSource: items,
        error: null,
        process: {
          status: true,
          action: 'taxBookRequest',
          message: response.data?.result_msg || 'Success',
        },
      };
    }

    case actions.TAX_BOOK_ERROR:
      return {
        ...state,
        loader: false,
        error: action.payload.message,
        process: {
          status: false,
          action: 'taxBookRequest',
          message: action.payload.message,
        },
      };

    case actions.TAX_BOOK_RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};


